import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { delay, Observable, of } from 'rxjs';
import { environment } from "src/environments/environment";
import { elpropietariotienepolizaasactivas, happypathmock, happypathmock2error } from "./sarlaft/happypath/happypath";
import { mockpay1, mockpay2, mockpay2Error } from "./sarlaft/happypath/pagar1/pagar1";
import { Error404, errorNoreconozcominumero, errornoreconozcominumero21, errorotp03escenario24, errorotp05escenario26, otpsuccess } from "./sarlaft/happypath/pagar1/otp1";
import { mock404Error, mockRiesgoAlto21Error, mockRisgomediodos, succesfullriesgobajomock, succesfullriesgomediomock2 } from "./sarlaft/happypath/pagar1/otp1ngnit";
import { escenario21otpfallido, mock4004, mockerror42otp03, mockOtpantalla2Error2, successmock } from "./sarlaft/happypath/pagar1/otpcode";
import { ExamDataallA } from "./inquilino/riesgo-medio/riesgo-medio";
import { ExamDataallB, mockRiesgoMedioErrorQues, mockRiesgoMedioSegundoError, mockRiesgoMediosuccess } from "./sarlaft/happypath/pagar1/securityquestion";
import { mockcontractsigningyes } from "./sarlaft/happypath/pagar1/firma-contrato";
import { mockcontractsign404, mockcontractsigningno } from "./inquilino/firma-contrato/firma-contrato";
import { inactividadopt1 } from "./sarlaft/happypath/pagar1/inactividad";

export class SarlaftInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.endsWith(environment.URL_MULESOFT_ORQUESTADOR_SARLAFT)) {
            console.log('entra en el interceptor de sarlaft' + JSON.stringify(req.body));
            console.log('req.url', req.url);

            // Log headers in a readable format
            console.log('req.headers:');
            req.headers.keys().forEach(key => {
                console.log(`${key}: ${req.headers.get(key)}`);
            });

            if (req.body && req.body.ExamData) { // para pantallas de riesgo medio

                if (req.body.ExamData == ExamDataallA) {
                    console.log('ExamDataallA');
                    return of(new HttpResponse({ status: 200, body: mockRiesgoMediosuccess })).pipe(delay(3000));
                } else if (req.body.ExamData == ExamDataallB) {
                    console.log('ExamDataallB');
                    return of(new HttpResponse({ status: 200, body: mockRiesgoMedioErrorQues })).pipe(delay(3000));
                }
                console.log('ExamDataallC');
                return of(new HttpResponse({ status: 200, body: mockRiesgoMedioSegundoError })).pipe(delay(3000));
            }
            if (req.body && req.body.validatePhone) { // pantalla 1 otp riesgo bajo

                if (req.body.listPhones[0].isSelect === true) {
                    return of(new HttpResponse({ status: 200, body: otpsuccess })).pipe(delay(3000));
                } else if (req.body.listPhones[1].isSelect === true) {
                    return of(new HttpResponse({ status: 200, body: errorotp05escenario26 })).pipe(delay(3000));
                } else if (req.body.listPhones[2].isSelect === true) {
                    return of(new HttpResponse({ status: 200, body: errorNoreconozcominumero })).pipe(delay(3000));
                }
                else if (req.body.listPhones[3].isSelect === true) {
                    return of(new HttpResponse({ status: 200, body: errorotp03escenario24 })).pipe(delay(3000));
                } else if (req.body.listPhones[4].isSelect === true) {
                    return of(new HttpResponse({ status: 404, body: Error404 })).pipe(delay(3000));
                }
            }

            if (req.body && req.body.screenPercentage) {

                return of(new HttpResponse({ status: 200, body: inactividadopt1 })).pipe(delay(3000));
            }


            if (req.body && req.body.resendOTP) {
                console.log('entra resend');
                return of(new HttpResponse({ status: 200, body: mock4004 })).pipe(delay(3000));

            }



            if (req.body && req.body.validateVerificarOTP) { // riesgo bajo otp pantalla 2

                if (req.body.PinNumber === "111111") {
                    return of(new HttpResponse({ status: 200, body: successmock })).pipe(delay(3000));
                } else if (req.body.PinNumber === "111112") {
                    if (req.body.countResend === 3) {
                        return of(new HttpResponse({ status: 200, body: mockOtpantalla2Error2 })).pipe(delay(3000));
                    }
                    return of(new HttpResponse({ status: 200, body: escenario21otpfallido })).pipe(delay(3000));
                } else if (req.body.PinNumber === "111113") {
                    return of(new HttpResponse({ status: 200, body: mockerror42otp03 })).pipe(delay(3000));
                } else {
                    return of(new HttpResponse({ status: 400, body: mock4004 })).pipe(delay(3000));
                }
            }

            if (req.body && req.body.signedContract) { // para firma de contrato 
                if (req.body.signedContract === true) {
                    console.log('firma contrato true');
                    return of(new HttpResponse({ status: 200, body: mockcontractsigningyes })).pipe(delay(3000));
                } else if (req.body.signedContract === false) {
                    console.log('firma contrato false');
                    return of(new HttpResponse({ status: 200, body: mockcontractsigningno })).pipe(delay(3000));
                }
            }


            if (req.body && req.body.quoteId && (req.body.getInitialDataPago === true || req.body.getResumeDataPago === true)) {
                {
                    return of(new HttpResponse({ status: 200, body: happypathmock })).pipe(delay(3000));
                }

            }
            if (req.body && req.body.quoteId && req.body.getPay === "true") {
                {
                    return of(new HttpResponse({ status: 200, body: mockpay1 })).pipe(delay(3000));
                }
            }
            if (req.body && req.body.quoteId && req.body.getSarlaft === 'true') {
                {
                    return of(new HttpResponse({ status: 200, body: mockpay2 })).pipe(delay(3000));
                }
            }
            return of(new HttpResponse({ status: 200, body: succesfullriesgobajomock })).pipe(delay(3000));
        }
        return next.handle(req);
    }

}